import React from "react";
import classes from "./Footer.module.css"

const Footer = () => {
    return (
        <footer>
            <h1>Контактная информация</h1>
            <div className={classes.footerContent}>
                <div>
                    <br/>
                    <h3>ООО “ЭнергоТестСервис”</h3>
                    <br/>
                    <h2>Адрес</h2>
                    <h3>423815, Республика Татарстан, г. Набережные Челны, ул. 40 ЛетПобеды, д. 61(53/39А), к. 002</h3>
                </div>
                <div>
                    <br/>
                    <h2>Номер телефона</h2>
                    <a href="tel:+79375865788"><h3>+7 (937) 586 57 88</h3></a>
                    <br/>
                    <h2>Почта</h2>
                    <a href="mailto:Etserv20@gmail.com"><h3>Etserv20@gmail.com</h3></a>
                </div>
            </div>
            <div>
                <h4>2026 © ООО ЭнергоТестСервис</h4>
            </div>
        </footer>
    )
}

export default Footer